import React, { useEffect, useState } from "react";
import { Card, Box, CardContent, Grid, Button, Chip, Typography } from "@mui/material";
import { IconButton } from "@mui/material";
import { ExitToApp } from "@mui/icons-material";
import profilePicture from "../../assets/user.png";
import CustomLabel from "./common/customLabel";
import { Link } from "react-router-dom";
import {
  imgProfileCard,
  labelNombreProfileCard,
  labelInfoProfileCard,
  botonVerPerfilProfileCard,
  botonLogoutProfileCard,
} from "../global/styles";
import { useSelector } from "react-redux";
import { useProfilePhoto } from "../context/profilePhotoContext";
import colors from "../../config/colors";

const ProfileCard = ({ handleClosePopover, onPressExit }) => {
  const featureFlags = useSelector((state) => state.configuration.feauteFlags)
  const infoAfiliado = useSelector((state) => state.afiliado.infoAfiliado);
  const ultraDarkMode = useSelector((state) => state.afiliado.infoAfiliado.ultraDarkMode);
  const isDark = infoAfiliado.isUltra && ultraDarkMode;
  const isUltraLight = infoAfiliado.isUltra && !ultraDarkMode;
  const [selectedFile, setSelectedFile] = useState(null)
  const {profilePhoto} = useProfilePhoto();

  const obtenerFotoPerfil = () => {
		const image = localStorage.getItem('selectedImage');
    
		if(image)
		{
			setSelectedFile(image)
			
		}
	}

  useEffect(() => {

    if(!selectedFile)
    {
      obtenerFotoPerfil()
    }
  
  }, [])

  return (
    <>
      <Card sx={{
        display: "flex",
        maxWidth: 380,
        position: 'relative',
        borderRadius: infoAfiliado.isUltra ? '16px' : '8px',
        border: isDark
          ? 'none'
          : isUltraLight
          ? `1px solid ${colors.ulBorder}`
          : 'none',
        boxShadow: 'none',
        overflow: 'hidden',
        background: isDark
          ? 'linear-gradient(160deg, #0d0d0d 0%, #1c1c1c 60%, #242424 100%)'
          : 'white',
      }}>
        {/* Top shimmer strip — removed: creates visible white line in dark mode */}
        <Box sx={{ display: "flex", width: '100%' }}>
          <CardContent sx={{ width: '100%', p: infoAfiliado.isUltra ? '0 !important' : '16px !important' }}>
            {/* Avatar + info row */}
            <Box sx={{
              display: 'flex', alignItems: 'center', gap: 2,
              px: infoAfiliado.isUltra ? 2.5 : 0,
              pt: infoAfiliado.isUltra ? 2.5 : 0,
              pb: infoAfiliado.isUltra ? 2 : 1,
              borderBottom: isDark ? '1px solid rgba(255,255,255,0.04)' : isUltraLight ? `1px solid ${colors.ulBorder}` : 'none',
            }}>
              <Box sx={{ position: 'relative', flexShrink: 0 }}>
                <img
                  src={!profilePhoto ? profilePicture : `data:image/png;base64,${profilePhoto}`}
                  width={72}
                  height={72}
                  style={{
                    ...imgProfileCard,
                    marginTop: 0,
                    objectFit: 'cover',
                    borderRadius: '50%',
                    border: isDark ? 'none' : isUltraLight ? `2px solid ${colors.ulBorder}` : undefined,
                  }}
                />
                {infoAfiliado.isUltra && (
                  <Box sx={{
                    position: 'absolute', bottom: -2, left: '50%',
                    transform: 'translateX(-50%)',
                    px: 0.8, py: 0.1,
                    borderRadius: '8px',
                    background: isDark ? '#1a1a1a' : colors.ulCardDark,
                    border: isDark ? '1px solid rgba(255,255,255,0.08)' : 'none',
                    whiteSpace: 'nowrap',
                    pointerEvents: 'none',
                  }}>
                    <Typography sx={{ color: '#b0b0b0', fontSize: 8, fontWeight: 800, letterSpacing: 1.8 }}>
                      ULTRA
                    </Typography>
                  </Box>
                )}
              </Box>

              <Box sx={{ flex: 1 }}>
                <CustomLabel style={{
                  ...labelNombreProfileCard,
                  color: isDark ? '#e8e8e8' : isUltraLight ? colors.ulText : undefined,
                  fontSize: infoAfiliado.isUltra ? 14 : 15,
                }}>
                  <label>{infoAfiliado.nombres} {infoAfiliado.apellidos}</label>
                </CustomLabel>
                <CustomLabel style={{
                  ...labelInfoProfileCard,
                  color: isDark ? 'rgba(255,255,255,0.45)' : isUltraLight ? colors.ulTextSec : undefined,
                  fontSize: infoAfiliado.isUltra ? 12 : 13,
                }}>
                  {infoAfiliado.tipoAfiliacion.toLowerCase() === 'titular' ? infoAfiliado.tipoAfiliacion : 'Dependiente'} {infoAfiliado.regimen}
                </CustomLabel>
                <CustomLabel style={{
                  ...labelInfoProfileCard,
                  color: isDark ? 'rgba(255,255,255,0.45)' : isUltraLight ? colors.ulTextSec : undefined,
                  fontSize: infoAfiliado.isUltra ? 12 : 13,
                }}>
                  No. de afiliado: <label>{infoAfiliado.codigoAfiliado}</label>
                </CustomLabel>
              </Box>
            </Box>

            {/* Buttons */}
            <Box sx={{
              display: 'flex', justifyContent: 'space-between', alignItems: 'center',
              px: infoAfiliado.isUltra ? 2.5 : 0,
              pt: 2,
              pb: infoAfiliado.isUltra ? 2.5 : 0,
            }}>
              {featureFlags.verPerfil && (
                <Link onClick={handleClosePopover} to='/profile' style={{ textDecoration: "none", flex: 1, marginRight: 8 }}>
                  <Button
                    id="btn-ver-perfil"
                    variant='contained'
                    fullWidth
                    style={{
                      ...botonVerPerfilProfileCard,
                      ...(isDark ? {
                        background: 'linear-gradient(135deg, #2a2a2a, #383838)',
                        backgroundColor: undefined,
                        color: '#e0e0e0',
                        border: '1px solid rgba(255,255,255,0.10)',
                        borderRadius: '10px',
                      } : isUltraLight ? {
                        background: colors.ulCardDark,
                        backgroundColor: undefined,
                        color: 'white',
                        border: 'none',
                        borderRadius: '10px',
                      } : {}),
                    }}
                    sx={{ fontSize: { xs: 15, md: 15 } }}
                  >
                    Ver perfil
                  </Button>
                </Link>
              )}
              <IconButton
                id="btn-logout"
                size='medium'
                style={{ ...botonLogoutProfileCard }}
                sx={isDark ? {
                  background: 'rgba(255,255,255,0.05)',
                  border: '1px solid rgba(255,255,255,0.09)',
                  color: '#888',
                  '&:hover': { background: 'rgba(255,255,255,0.10)' },
                } : isUltraLight ? {
                  background: 'rgba(0,0,0,0.04)',
                  border: `1px solid ${colors.ulBorder}`,
                  color: colors.ulTextSec,
                  '&:hover': { background: 'rgba(0,0,0,0.08)' },
                } : {}}
                onClick={onPressExit}
              >
                <ExitToApp />
              </IconButton>
            </Box>
          </CardContent>
        </Box>
      </Card>
    </>
  );
};

export default ProfileCard;
